import { Route } from "react-router-dom";
import { isDebugMode } from "common/utils";
import { Builder } from "features/builder";
import { SokobanGamePage } from "features/courses/sokoban";
import { ProgramGamePage } from "features/courses/program/game";
import { AlgorithmGamePage } from "features/courses/algorithm/game";
import { ProgramLevelMapPage } from "features/courses/program/stage";
import { AlgorithmLevelMapPage } from "features/courses/algorithm/stage";
import { AlgorithmTangibleGamePage } from "features/courses/algorithm_tangible/game";
import { AlgorithmTangibleLevelMapPage } from "features/courses/algorithm_tangible/stage";
import { CourseTopPage } from "./CourseTop";

export const CoursePageRoutes = (
  <>
    <Route index element={<CourseTopPage />} />
    <Route path="algorithm">
      <Route path="stage/:stageId" element={<AlgorithmLevelMapPage />} />
      <Route path="stage/:stageId/step/:stepId" element={<AlgorithmGamePage />} />
    </Route>
    <Route path="program">
      <Route path="stage/:stageId" element={<ProgramLevelMapPage />} />
      <Route path="stage/:stageId/step/:stepId" element={<ProgramGamePage />} />
    </Route>
    <Route path="algorithm_tangible">
      <Route path="stage/:stageId" element={<AlgorithmTangibleLevelMapPage />} />
      <Route path="stage/:stageId/step/:stepId" element={<AlgorithmTangibleGamePage />} />
    </Route>
    {isDebugMode && (
      <>
        <Route path="sokoban">
          <Route path="level/:levelId" element={<SokobanGamePage />} />
        </Route>
        <Route path="builder/*" element={<Builder />} />
      </>
    )}
  </>
);
